import React, { useCallback, useMemo } from 'react';

import { PieChartAnalyticsData, GraphKeyAndColour } from '../../../shared/analytics/PieChart';
import styles from '../PortfolioAnalytics.module.scss';
import { BarChartAnalytics } from '../../../shared/analytics/BarChart';
import { VerticalBarChart } from '../../../shared/analytics/VerticalBarChart';

const { french } = styles;

interface PortfolioAnalyticsBarChartProps {
    chartHeight: number;
    chartWidth: number;
    data: PieChartAnalyticsData[];
    onHover: (data: BarChartAnalytics | null) => void;
    graphColours: GraphKeyAndColour;
}

export const PortfolioAnalyticsBarChart: React.FC<PortfolioAnalyticsBarChartProps> = ({ chartHeight, chartWidth, data, onHover, graphColours }) => {
    const barChartData = useMemo(() => data.reduce((acc: BarChartAnalytics[], { key, value }, index) => [...acc, { id: index, name: key, percentageFill: value }], []), [data]);
    const getBackgroundColor = useCallback((name: string) => graphColours[name] || french, [graphColours]);

    return (
        <div className={styles.chartWrapper} style={{ height: `${chartHeight}px`, width: `${chartWidth}px` }}>
            <VerticalBarChart
                data={barChartData}
                height={chartHeight}
                width={chartWidth}
                onHover={onHover}
                barWidth={70}
                getBackgroundColor={getBackgroundColor}
            />
        </div>
    );
};
